import { lazy } from 'react'

export const EasyToFollowPlanV1 = lazy(() => import('./v1/EasyToFollowPlanV1'))
